// Shared by every To/Cc/Bcc autocomplete field (ReplyComposer + ComposeDialog).
// The text match itself happens server-side (contacts_cache `.ilike()` in
// useContacts) — this just decides whether the debounced query is long
// enough to bother, and drops contacts already added to that field.

export interface ContactSuggestionCandidate {
  email: string | null;
  full_name?: string | null;
  is_existing_client?: boolean | null;
}

export function selectContactSuggestions<T extends ContactSuggestionCandidate>(
  contacts: T[],
  query: string,
  excluding: string[],
): T[] {
  if (query.trim().length < 2) return [];
  const excludeSet = new Set(excluding.map((e) => e.toLowerCase()));
  return contacts
    .filter((c) => c.email && !excludeSet.has(c.email.toLowerCase()))
    .slice(0, 5);
}
